import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import AmortizationPageUI from './AmortizationPageUI.js'

class AmortizationPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      schedule: null,
      response: null
    }
  }

  render() {
    return (
      <AmortizationPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        account={this.state.account}
        schedule={this.state.schedule}
        response={this.state.response}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
    this.getAmortizations(context)
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    let context = this.props.context
    this.setState({ errorList: response.errorList, loan: response.loan })
    this.getAccount(context, response.loan.accountId)
  }

  getAccount(context, accountId) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${accountId}`,
      cacheKey: CacheKeys.Account(accountId),
      callback: this.getAccountCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountCallback = (response) => {
    this.setState({ account: response.account })
  }

  getAmortizations(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/amortizations`,
      cacheKey: CacheKeys.Amortizations(this.props.match.params.loanId),
      callback: this.getAmortizationsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getAmortizationsCallback = (response) => {
    this.setState({ errorList: response.errorList, schedule: response.schedule, response: response })
  }

  onRefreshClick = () => {
    let loan = this.state.loan
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Loan(loan.loanId))
    CacheManager.removeObject(CacheKeys.Amortizations(loan.loanId))
    this.setState({
      loan: null,
      schedule: null,
      dsraF2: null,
      errorList: null,
    })
    this.getLoan(context)
    this.getAmortizations(context)
  }
}

export default withRouter(AmortizationPageSF)
